module.exports = __webpack_public_path__ + "img/projetos_grey.e2d804f5.png";